import React from 'react'
import './LoadingScreen.scss'

/**
 * Full-viewport loading state for app-wide gates (auth, bootstrap, lazy
 * routes). Library-neutral, so it renders the same whether or not the legacy
 * stylesheet is active.
 */
function LoadingScreen() {
  return (
    <div className='loading-screen' role='status' aria-label='Loading'>
      <span className='loading-screen__spinner' />
    </div>
  )
}

export default LoadingScreen
